import React from 'react'
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import asset from '../../../images/asset-management.jpeg';
import legend from '../../../images/products/30_2041844726.jpg';
import hydrogen from '../../../images/home/24_2168999393.jpg';
import '../../../styles/mainItem.css'

const Hydrogen = () => {

    const handleScrollToTop = () => {
        // Smooth scroll to the top of the page
        window.scrollTo(0, 0)
    };

    return (
        <div className='main-page'>
            <Image src={legend} fluid className="mainItemPage-img" />
            <div className='sub-items'>
                <Container>
                    <h1 className='mb-4'>Hydrogen Production & Storage</h1>
                    <hr className='mb-4' />
                    <Row className='justify-content-md-start'>
                        <Col xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card className='sub-items-card' as={Link} to="/products/hydrogen/index" onClick={handleScrollToTop}>
                                <Card.Body>
                                    <p>Hydrogen Production & Storage</p>
                                    <div className='card-image-frame'>
                                        <Image src={hydrogen} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default Hydrogen